import { type PropsWithChildren } from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsContent = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <ScrollView bounces={false} contentContainerStyle={styles.content} overScrollMode="never">
      {children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  content: {
    gap: theme.spacing['6'],
  },
});
